export default __webpack_public_path__ + "static/media/pethelp_mobile.a887c7ec.webp";